module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "achievement"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.nowType == 'month') ? _c('div', {
    staticClass: "left monthBox clearfix"
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.cutMonth(0)
      }
    }
  }, [_vm._v("上一月")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "left",
    attrs: {
      "picker-options": _vm.pickerOptions0,
      "type": "month",
      "placeholder": "选择月"
    },
    on: {
      "change": _vm.cutDataFn
    },
    model: {
      value: (_vm.yearMonth),
      callback: function($$v) {
        _vm.yearMonth = $$v
      },
      expression: "yearMonth"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.cutMonth(1)
      }
    }
  }, [_vm._v("下一月")])], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'timeRange') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "quick-filter"
  }, [_c('span', {
    class: _vm.nowSelFilter == 'today' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('today')
      }
    }
  }, [_vm._v("今日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastDay' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastDay')
      }
    }
  }, [_vm._v("昨日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'week' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('week')
      }
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastWeek' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastWeek')
      }
    }
  }, [_vm._v("上周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'month' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('month')
      }
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastMonth' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastMonth')
      }
    }
  }, [_vm._v("上月")])]), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.achieveArr.length > _vm.pageSize
    }
  }, _vm._l((_vm.achieveArr), function(item) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.employeeCode)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.employeeName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "13%"
      },
      domProps: {
        "textContent": _vm._s(item.groupName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      },
      domProps: {
        "textContent": _vm._s(item.orderCount)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      },
      domProps: {
        "textContent": _vm._s(item.target)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "achievement-name",
      staticStyle: {
        "width": "14%"
      },
      domProps: {
        "textContent": _vm._s(item.totalAmount)
      },
      on: {
        "click": function($event) {
          return _vm.openMoneyDetail(item)
        }
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.addMemberNumber)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "achievement-name",
      staticStyle: {
        "width": "14%"
      },
      domProps: {
        "textContent": _vm._s(item.totalCommission)
      },
      on: {
        "click": function($event) {
          _vm.curPage = 1;
          _vm.commissionDetail(item)
        }
      }
    })])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "out-excel"
  }, [_c('div', {}, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '本月业绩  ' + _vm.employeeInfo.employeeName,
      "visible": _vm.openLoss,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.openLoss = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "mobile-style"
    }
  }, [_c('div', {
    staticClass: "lossTotal flex flex-align-center"
  }, [_c('span', {
    staticClass: "span1"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "span2 blue",
    domProps: {
      "textContent": _vm._s(_vm.employeeInfo.productCount)
    }
  }), _c('span', {
    staticClass: "span3"
  }, [_vm._v("件商品")]), _vm._v(" "), _c('span', {
    staticClass: "span1"
  }, [_vm._v("合计")]), _c('span', {
    staticClass: "span2 red"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.employeeInfo.totalAmount)))]), _vm._v(" "), _c('span', {
    staticClass: "span3"
  }, [_vm._v("元")])]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "goodList"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "idx left color1"
  }, [_vm._v("序号")]), _vm._v(" "), _c('span', {
    staticClass: "data left color1"
  }, [_vm._v("时间")]), _vm._v(" "), _c('span', {
    staticClass: "name left color1"
  }, [_vm._v("订单号")]), _vm._v(" "), _c('span', {
    staticClass: "number left color1"
  }, [_vm._v("提成金额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "space1"
  }), _vm._v(" "), _c('ul', {
    staticClass: "goodList"
  }, _vm._l((_vm.commissionOrder), function(item, ind) {
    return _c('li', {
      staticClass: "clearfix lis"
    }, [_c('span', {
      staticClass: "idx left",
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "data left"
    }, [_vm._v(_vm._s(_vm._f("numberToAllDate")(item.paymentTime, '')))]), _vm._v(" "), _c('span', {
      staticClass: "name left",
      domProps: {
        "textContent": _vm._s(item.code)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "number left"
    }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(item.commission)))])])
  }), 0)])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '本月营业额 ' + _vm.nowMoneyDetailName,
      "visible": _vm.moneyDetail,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.moneyDetail = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "mobile-style"
    }
  }, [_c('div', {
    staticClass: "space1",
    staticStyle: {
      "width": "100%",
      "height": "15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "idx left color1",
    staticStyle: {
      "width": "50%",
      "text-align": "left"
    }
  }, [_vm._v("分类名称")]), _vm._v(" "), _c('span', {
    staticClass: "data left color1",
    staticStyle: {
      "width": "10%",
      "text-align": "center"
    }
  }, [_vm._v("销售数量")]), _vm._v(" "), _c('span', {
    staticClass: "number left color1",
    staticStyle: {
      "width": "20%",
      "text-align": "center"
    }
  }, [_vm._v("销售金额")]), _vm._v(" "), _c('span', {
    staticClass: "number left color1",
    staticStyle: {
      "width": "20%",
      "text-align": "center"
    }
  }, [_vm._v("提成金额")])]), _vm._v(" "), _c('div', {
    staticClass: "space1",
    staticStyle: {
      "width": "100%",
      "height": "15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('ul', {
    staticClass: "goodList"
  }, _vm._l((_vm.moneyDetailData), function(item, ind) {
    return _c('li', {
      staticClass: "clearfix lis p",
      on: {
        "click": function($event) {
          return _vm.doShowChild(ind)
        }
      }
    }, [_c('span', {
      staticClass: "idx left",
      staticStyle: {
        "width": "50%",
        "text-align": "left"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "data left",
      staticStyle: {
        "width": "10%",
        "text-align": "center"
      }
    }, [_vm._v("\n                                        " + _vm._s(item.qty) + "\n                                        "), (item.data && item.diffQty) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": ("其中包含" + (item.typeName) + "一级分类下的商品销售数：" + (item.diffQty)),
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "wen"
    }, [_vm._v("?")])]) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "number left",
      staticStyle: {
        "width": "20%",
        "text-align": "center"
      }
    }, [_vm._v("\n                                        ￥" + _vm._s(item.amount.toFixed(2)) + "\n                                        "), (item.data && item.diffAmount) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": ("其中包含" + (item.typeName) + "一级分类下的商品销售金额：" + (item.diffAmount.toFixed(2))),
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "wen"
    }, [_vm._v("?")])]) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "number left",
      staticStyle: {
        "width": "20%",
        "text-align": "center"
      }
    }, [_vm._v("\n                                        ￥" + _vm._s(item.commission.toFixed(2)) + "\n                                        "), (item.data && item.diffCommission) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": ("其中包含" + (item.typeName) + "一级分类下的提成金额：" + (item.diffCommission.toFixed(2))),
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "wen"
    }, [_vm._v("?")])]) : _vm._e()], 1), _vm._v(" "), (item.data && Array.isArray(item.data) && item.data.length) ? _c('div', {
      staticClass: "child",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, _vm._l((item.data), function(cIt, cInd) {
      return _c('li', {
        staticClass: "clearfix lis"
      }, [_c('span', {
        staticClass: "idx left",
        staticStyle: {
          "width": "50%",
          "text-align": "left"
        }
      }, [_vm._v("---" + _vm._s(cIt.typeName))]), _vm._v(" "), _c('span', {
        staticClass: "data left",
        staticStyle: {
          "width": "10%",
          "text-align": "center"
        }
      }, [_vm._v(_vm._s(cIt.qty))]), _vm._v(" "), _c('span', {
        staticClass: "number left",
        staticStyle: {
          "width": "20%",
          "text-align": "center"
        },
        domProps: {
          "textContent": _vm._s('￥' + cIt.amount.toFixed(2))
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "number left",
        staticStyle: {
          "width": "20%",
          "text-align": "center"
        },
        domProps: {
          "textContent": _vm._s('￥' + cIt.commission.toFixed(2))
        }
      })])
    }), 0) : _vm._e()])
  }), 0)])])])])], 1)]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("工号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("岗位")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("总订单量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("销售目标(元)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("总营业额(元)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("推荐会员数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("提成金额(元)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-69d4e70a","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/employee/achievement.vue
// module id = 957
// module chunks = 1